import { BookingCard } from "components";

// Swiper Slider
import { Swiper, SwiperSlide } from "swiper/react";

export default function RecentBooking({ isLoading, data }) {
  return (
    <div className="w-full flex flex-col mb-[40px] md:mb-[60px]">
      <div className="text-base md:text-2xl font-semibold text-black mb-4 md:mb-6">
        Recent Booking
      </div>
      <div className="w-full flex">
        <Swiper
          slidesPerView={1.1}
          spaceBetween={16}
          style={{ width: "100%" }}
          breakpoints={{
            420: {
              slidesPerView: 1.1,
            },
            640: {
              slidesPerView: 2.2,
            },
            980: {
              slidesPerView: 2.6,
            },
          }}
        >
          {data.map((item, index) => (
            <SwiperSlide key={index}>
              <BookingCard key={index} item={item} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}
